import { Component, Vue, Mixins, Prop, Emit } from 'vue-property-decorator';
import CommonView from '@/views/CommonView';
import OCTtlMain from '@/components/OCTtlMain.vue';
import OCButtonSmall from '@/components/OCButtonSmall.vue';
import OCUserData from '@/components/OCUserData.vue';
import OCFormLabel from '@/components/OCFormLabel.vue';
import OCTextBox from '@/components/OCTextBox.vue';
import OCMailAuthentication from '@/components/OCMailAuthentication.vue';
import BASEAPI from "@/util/BASEAPI";
import { OCMailAuthenticationResponse } from '@/components/OCMailAuthentication';
import { AxiosErrorHandler, isAxiosError } from '@/util/AxiosErrorHandler';

@Component({
    components: {
        OCTtlMain,
        OCButtonSmall,
        OCUserData,
        OCFormLabel,
        OCTextBox,
        OCMailAuthentication,
    },
})
export default class NewUser extends Mixins(CommonView) {
    pnkzList: {name: string, path: string | null}[] = [];

    mode: number = 0;

    user: BASEAPI.User = <BASEAPI.User>{};

    passConfirmation: string = "";

    error: string = "";
    redirectUrl: string = "/";
    kurukuru: boolean = false;
    term: boolean = true;
    element: HTMLElement = <HTMLElement>document.scrollingElement;

    type: string = 'edit';

    @Prop({
        type: Object,
        default: {},
    })
    reminderToNewUser!: OCMailAuthenticationResponse;

    public async created() {
        this.user = BASEAPI.user();
        if (this.$route.query && this.$route.query.url && typeof this.$route.query.url === "string") {
            this.redirectUrl = this.$route.query.url;
        }

        if (this.reminderToNewUser) {
            this.user.email = this.reminderToNewUser.email;
            this.user.code = this.reminderToNewUser.code;
            this.mode = 1;
        }

        this.pnkzList = [
            {name: "TOP", path: "/"},
            {name: "会員登録", path: null}
        ];
    }

    @Emit("reminder")
    public reminder(val: OCMailAuthenticationResponse) {
        return val;
    }

    public ok0(val: OCMailAuthenticationResponse) {
        if (val.user) {
            this.reminder(val);
            return;
        }
        this.user.email = val.email;
        this.user.code = val.code;
        this.element.scrollTop = 0;
        this.mode = 1;
    }

    public async ok1() {
        this.error = "";
        this.element.scrollTop = 0;
        this.mode = 2;
    }

    public async ok2() {
        this.error = "";
        if (!this.user.gender) {
            this.error = "性別が未回答です。";
            this.element.scrollTop = 0;
            return;
        }

        if (this.user.address.indexOf(',' ) !== -1 || this.user.address2.indexOf(',' ) !== -1) {
            this.error = "住所にはカンマ「 , 」は使用できません。";
            this.element.scrollTop = 0;
            return;
        }

        if (!this.user.password) {
            this.error = "パスワードが未入力です。";
            this.element.scrollTop = 0;
            return;
        }

        this.kurukuru = true;
        let res = await BASEAPI.UserController.postUserUsingPOST(this.user).catch(AxiosErrorHandler);
        if (isAxiosError(res)) {
            this.error = "" + res.data;
            this.mode = 1;
        } else {
            this.mode = 3;
        }

        this.element.scrollTop = 0;
        await this.getUserAPI();
        this.kurukuru = false;
    }

    public back(value: number) {
        this.mode = value;
        this.element.scrollTop = 0;
    }

    public backRedirect() {
        this.$router.push(this.redirectUrl);
    }

}

